import {ChangeEvent} from "react";

export enum TileCoordinateType {
    GRID,
    TRAY_PLAYER,
    TRAY_AI
}

export interface TileCoordinates {
    location: TileCoordinateType,
    index: number
}

export interface Letter {
    str: string,
    points: number,
    is_blank: boolean,
}

export interface TileData {
    letter: Letter,
    isEphemeral: boolean,
    recentlyPlayed: boolean,
    coordinates: TileCoordinates,
}

export type ModifyTileStoreFunctionType = (newCoordinates: TileCoordinates, newData: TileData) => void;

export function Tile(props: {data: TileData, modifyTileStore: ModifyTileStoreFunctionType}){

    // Basically, if it's in the grid and it's fixed, don't let it be draggable
    const isDraggable = props.data.coordinates.location != TileCoordinateType.GRID || props.data.isEphemeral;

    function onDragStart(e){
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('scrapple/tile', JSON.stringify(props.data));
    }

    // Only applicable for ephemeral tiles
    function onDrop(e){
        const newTileData: TileData = JSON.parse(e.dataTransfer.getData("scrapple/tile"));
        newTileData.isEphemeral = false;

        console.log({tileData: newTileData})

        props.modifyTileStore(props.data.coordinates, newTileData);

        e.preventDefault();
    }

    let tileClass = "tile-with-letter";
    if(props.data.isEphemeral) {
        tileClass = tileClass + ' ephemeral';
    }

    if(props.data.recentlyPlayed) {
        tileClass = tileClass + ' ai-played';
    }


    // Need to handle blanks

    function modifyThisLetter(value:string){
        const newTileData: TileData = {
            letter: props.data.letter,
            isEphemeral: props.data.isEphemeral,
            coordinates: props.data.coordinates,
            recentlyPlayed: props.data.recentlyPlayed,
        };
        newTileData.letter.str = value;

        props.modifyTileStore(props.data.coordinates, newTileData);
    }

    function onBlankInput(e: ChangeEvent<HTMLInputElement>){
        let value = e.target.value.toUpperCase();
        if(value.length > 1){
            value = value[value.length - 1];
        } else if(value.length == 0){
            modifyThisLetter(value);
            return;
        }

        // Now check that it's a letter
        let is_letter = value.match("[A-Z]") != null;
        if(is_letter){
            modifyThisLetter(value);
        } else {
            // Cancel and do nothing
            e.preventDefault();
        }

    }


    let letterElement = <div className="text">{props.data.letter.str}</div>;
    if(props.data.letter.is_blank && (props.data.isEphemeral || props.data.coordinates.location != TileCoordinateType.GRID)){
        letterElement = <input className="blank-input" type="text" onChange={onBlankInput} value={props.data.letter.str} />
    } else if(props.data.letter.is_blank){
        // not ephemeral
        letterElement = <div className="text prev-blank">{props.data.letter.str}</div>;
    }

    if(props.data.isEphemeral || props.data.coordinates.location != TileCoordinateType.GRID){
        return(
            <div
                className={tileClass}
                key={2}
                draggable={isDraggable}
                onDragStart={onDragStart}
                onDrop={onDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                {letterElement}
                <div className="value">{props.data.letter.points}</div>
            </div>
        );
    } else {
        return(
            <div
                className={tileClass}
                key={2}
                draggable={isDraggable}
                onDragStart={onDragStart}

            >
                {letterElement}
                <div className="value">{props.data.letter.points}</div>
            </div>
        );
    }
}